import React from 'react';
import { FormattedMessage } from 'react-intl';

const UpdatedFailedNotificationContent = () => {
    return (
        <FormattedMessage
        id="ids_updateFailed"/>
    );
}

export default UpdatedFailedNotificationContent;